import ShopMyStoreMain from 'components/ShopYourStore/ShopMyStoreMain/ShopMyStoreMain';
import { withShopMyStoreMainProps } from 'components/ShopYourStore/ShopMyStoreMain/withShopMyStoreMainProps';

export default withShopMyStoreMainProps(ShopMyStoreMain);
